import React from 'react';
import { remoteAccessDialogTitles } from '../../RemoteAccessDialogConstants';

function Header() {
  return (
    <div className="remote-access-dialog__header">
      <h3>{remoteAccessDialogTitles.ACTIVATION}</h3>
    </div>
  );
}

export default Header;
